var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThreedot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 14,
    viewBox: "0 0 4 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 3.66665C2.91666 3.66665 3.66666 2.91665 3.66666 1.99998C3.66666 1.08331 2.91666 0.333313 2 0.333313C1.08333 0.333313 0.333328 1.08331 0.333328 1.99998C0.333328 2.91665 1.08333 3.66665 2 3.66665ZM2 5.33331C1.08333 5.33331 0.333328 6.08331 0.333328 6.99998C0.333328 7.91665 1.08333 8.66665 2 8.66665C2.91666 8.66665 3.66666 7.91665 3.66666 6.99998C3.66666 6.08331 2.91666 5.33331 2 5.33331ZM2 10.3333C1.08333 10.3333 0.333328 11.0833 0.333328 12C0.333328 12.9166 1.08333 13.6666 2 13.6666C2.91666 13.6666 3.66666 12.9166 3.66666 12C3.66666 11.0833 2.91666 10.3333 2 10.3333Z",
    fill: "#3F4752"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreedot);
export default __webpack_public_path__ + "static/media/Threedot.b7c781ab0617689a61cc65a6cfb3a937.svg";
export { ForwardRef as ReactComponent };